const $ = require("jquery");

$(document).ready(function() {
  $(".tabs__list__link").on("click", function(event) {
    event.preventDefault();

    let type = $(this)
      .parent()
      .data("type");

    $(".tabs__list__item--is-active").removeClass(
      "tabs__list__item--is-active"
    );

    $(".tabs__panels__item--is-active").removeClass(
      "tabs__panels__item--is-active"
    );

    $("li[data-type=" + type + "]").addClass("tabs__list__item--is-active");
    $("div[data-type=" + type + "]").addClass("tabs__panels__item--is-active");
  });
});
